// extracted by mini-css-extract-plugin
export var infoItem = "_sy-2";
export var title = "_sy-0";
export var value = "_sy-1";